import { createAction } from 'typesafe-actions';
import { takeLatest, put } from 'redux-saga/effects';
import { ReviewFormActions } from 'features/review-form';
import { EReviewsElementBlock } from './types';

export namespace ReviewsGaFocus {
  const ACTION_NAME = 'GA:focus';

  /**
   * Событие должно срабатывать единоразово при взаимодействии с блоком
   *
   * @see https://docs.google.com/document/d/14v6VhSpFLlEPekvGSRJh5klKkGJp6oPhplFlxorrAyM/edit#heading=h.6iyxi97hhg11
   */
  export const writeReviewText = createAction(
    ACTION_NAME,
    ({ elementName }: { elementName: 'Общие впечатления' | 'Достоинства' | 'Недостатки' }) => ({
      elementType: 'input',
      elementBlock: EReviewsElementBlock.FORM,
      elementName,
      elementText: 'Отзыв',
    }),
  )();

  /**
   * Событие должно срабатывать единоразово при взаимодействии с блоком
   *
   * @see https://docs.google.com/document/d/14v6VhSpFLlEPekvGSRJh5klKkGJp6oPhplFlxorrAyM/edit#heading=h.8faf5nhy7gn6
   */
  export const writeAuthorDetails = createAction(
    ACTION_NAME,
    ({ elementName }: { elementName: 'Имя' | 'Почта' }) => ({
      elementType: 'input',
      elementBlock: EReviewsElementBlock.FORM,
      elementName,
      elementText: 'Ваши данные',
    }),
  )();
}

export function* runGaFocusDetector() {
  let bodyFieldFocusedReceived = false;
  yield takeLatest(ReviewFormActions.BODY_FIELD_FOCUSED, function* putGaFocus() {
    if (!bodyFieldFocusedReceived) {
      bodyFieldFocusedReceived = true;
      yield put(ReviewsGaFocus.writeReviewText({ elementName: 'Общие впечатления' }));
    }
  });

  let prosFieldFocusedReceived = false;
  yield takeLatest(ReviewFormActions.PROS_FIELD_FOCUSED, function* putProsFieldFocused() {
    if (!prosFieldFocusedReceived) {
      prosFieldFocusedReceived = true;
      yield put(ReviewsGaFocus.writeReviewText({ elementName: 'Достоинства' }));
    }
  });

  let consFieldFocusedReceived = false;
  yield takeLatest(ReviewFormActions.CONS_FIELD_FOCUSED, function* putConsFieldFocused() {
    if (!consFieldFocusedReceived) {
      consFieldFocusedReceived = true;
      yield put(ReviewsGaFocus.writeReviewText({ elementName: 'Недостатки' }));
    }
  });

  let authorNameFieldFocusedReceived = false;
  yield takeLatest(ReviewFormActions.AUTHOR_NAME_FIELD_FOCUSED, function* putAuthorNameFieldFocused() {
    if (!authorNameFieldFocusedReceived) {
      authorNameFieldFocusedReceived = true;
      yield put(ReviewsGaFocus.writeAuthorDetails({ elementName: 'Имя' }));
    }
  });

  let authorEmailFieldFocusedReceived = false;
  yield takeLatest(ReviewFormActions.AUTHOR_EMAIL_FIELD_FOCUSED, function* putAuthorEmailFieldFocused() {
    if (!authorEmailFieldFocusedReceived) {
      authorEmailFieldFocusedReceived = true;
      yield put(ReviewsGaFocus.writeAuthorDetails({ elementName: 'Почта' }));
    }
  });
}
